import { QUI_REGLE, REGLES, SCENARIO } from "./content2";
import { CardList, SectionShell } from "./blocks";
import { useInView } from "./useInView";

const Machine = () => (
  <div className="grid lg:grid-cols-2 gap-12">
    <div className="mm-body space-y-4">
      <h3 className="disp text-3xl md:text-4xl">La machine : pour être, pas pour paraître</h3>
      <p>Elle aide à retrouver le fil, classer, comparer, calculer, vérifier, reformuler et recommencer lorsque les données changent. Elle ne remplace pas la question : elle aide à mieux la poser.</p>
      <p>Utilisez-la pour apprendre. Pour comprendre. Pour construire. Pour tester vos scénarios. Pas seulement pour paraître.</p>
      <p className="disp text-xl">Naître. Paraître. Être. Disparaître.</p>
      <p>Le paraître passe. L'être laisse une trace.</p>
    </div>
    <div className="bg-mm-ink text-mm-paper p-8">
      <p className="mm-lab text-mm-goldlight">Le scénario reste le vôtre</p>
      <ol className="mt-4 space-y-3">
        {SCENARIO.map((s, i) => <li key={s} className="disp text-2xl"><span className="text-mm-gold mr-3">{i + 1}</span>{s}</li>)}
      </ol>
      <p className="mt-6 text-sm text-mm-cream">Rêve ou cauchemar ? Tout dépend de vos questions, de vos règles et de ce que vous décidez d'en faire. La science-fiction (Lucy, de Luc Besson) a déjà imaginé les scénarios : parmi tous ceux qu'elle nous a montrés, lequel sommes-nous en train de construire ?</p>
    </div>
  </div>
);

const Heritage = () => (
  <div className="border-t-4 border-mm-red pt-8 grid md:grid-cols-2 gap-10">
    <div>
      <h3 className="disp text-3xl md:text-4xl">L'héritage</h3>
      <p className="mm-body mt-3">Ce dossier n'est ni une vérité définitive, ni une réponse imposée. C'est une photographie : celle d'un territoire, la France, à un instant donné. Puis vient la transcription : non pour prédire demain, mais pour poser les bonnes questions.</p>
      <p className="mm-body mt-3 font-bold">Un héritage qui appartient à tous : à tous ceux qui voudront s'en saisir, le comprendre, le contester, l'améliorer et le transmettre à leur tour.</p>
    </div>
    <div className="mm-body">
      <p className="mm-lab text-mm-golddark">La transcription</p>
      <p className="mt-3">Quelle France voulons-nous transmettre ? Avec quelles règles ? Avec quelles priorités ? Avec quels moyens ? Quelle place pour l'homme ? Quelle place pour la machine ? Quelle responsabilité pour chacun ?</p>
      <p className="disp text-2xl mt-6 text-mm-red">La réponse est peut-être dans la question. À vous de continuer.</p>
    </div>
  </div>
);

export const Regles = () => {
  const [ref, cls] = useInView(0.05);
  return (
    <SectionShell id="regles" label="Les règles · La machine" bg="bg-mm-alt" innerRef={ref} cls={cls}>
      <div>
        <h2 className="disp mm-h2">Chacun chez soi. Chacun son indépendance.</h2>
        <p className="mm-body mt-3 mb-10">Liberté individuelle, règle collective, application, contrôle et sanction.</p>
        <CardList items={REGLES} />
        <p className="mm-lab mt-8 text-mm-golddark">Règles individuelles libres · Règle collective commune · Application · Respect · Contrôle · Sanction</p>
      </div>
      <div>
        <h3 className="disp text-3xl md:text-4xl">Qui va régler tout ça ?</h3>
        <p className="mm-body mt-3 mb-10">Sans passion ni débat. La machine ? À votre place ? Avec la machine ? Ou tous ensemble ?</p>
        <CardList items={QUI_REGLE} cols="md:grid-cols-2 lg:grid-cols-4" numbered={false} />
      </div>
      <Machine />
      <Heritage />
    </SectionShell>
  );
};
